/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Empty_No_Calendar_BodyInputs */



/**
* | output |
* | --- |
* | "The conversations Wundo follows appear here. Add one yourself, or connect your calendar so they appear here by themselves." |
*
* @param {Conversations_Empty_No_Calendar_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_empty_no_calendar_body = /** @type {((inputs?: Conversations_Empty_No_Calendar_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Empty_No_Calendar_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hier komen de gesprekken die Wundo mee opvolgt. Voeg er zelf een toe, of koppel je agenda zodat ze hier vanzelf verschijnen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les conversations que Wundo suit apparaissent ici. Ajoutez-en une vous-même, ou connectez votre agenda pour qu’elles apparaissent ici toutes seules.")
	return /** @type {LocalizedString} */ ("The conversations Wundo follows appear here. Add one yourself, or connect your calendar so they appear here by themselves.")
});